(() => {
  'use strict';

  if (window.Shopify?.designMode) return;

  let opening = false;
  let closeObserver;

  const requested = () => new URL(window.location.href).searchParams.get('open_cart') === '1';

  function clearRequest() {
    const url = new URL(window.location.href);
    if (!url.searchParams.has('open_cart')) return;
    url.searchParams.delete('open_cart');
    window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
  }

  async function openRequestedCart() {
    if (!requested() || opening || !window.customElements) return;
    opening = true;
    try {
      await customElements.whenDefined('m-cart-drawer');
      if (!requested()) return;
      const drawer = document.getElementById('MinimogCartDrawer');
      if (!drawer || typeof drawer.open !== 'function') return;
      closeObserver?.disconnect();
      let wasOpen = drawer.classList.contains('m-cart-drawer--active');
      closeObserver = new MutationObserver(() => {
        const isOpen = drawer.classList.contains('m-cart-drawer--active');
        if (isOpen) wasOpen = true;
        if (wasOpen && !isOpen) {
          clearRequest();
          closeObserver.disconnect();
        }
      });
      closeObserver.observe(drawer, { attributes: true, attributeFilter: ['class'] });
      if (!wasOpen) drawer.open(document.querySelector('.m-cart-icon-bubble'));
    } finally {
      opening = false;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', openRequestedCart, { once: true });
  } else {
    openRequestedCart();
  }

  window.addEventListener('pageshow', (event) => {
    if (event.persisted) openRequestedCart();
  });
  window.addEventListener('popstate', openRequestedCart);
})();
